import React from "react";
// @Mui
import { Box } from "@mui/material";
//
import Header from "./Header";
import FillFormNoticePopUp from "src/components/FillFormNoticePopUp";

// -------------------------------------------------------------

function DashboardLayout({ children }) {
  return (
    <Box>
      <Header />
      <Box sx={{ py: 4 }}>{children}</Box>
      <FillFormNoticePopUp />
    </Box>
  );
}

export default DashboardLayout;
